<template>
    <Layout>
        <div class="row">
            <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
                <b-tab active>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                      >{{ $t("hr_employees.tabs.attendance") }}
                    </span>
                  </template>
                  <EmployeeAttendes />
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    <div
                       @click="activate_calendar_attendance.loadCalendar();"
                       class=""
                     >
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                      >{{ $t("hr_employees.tabs.calender") }}
                    </span>
                    </div>
                  </template>
                  <employeeCalender :activate_calendar_attendance="activate_calendar_attendance"/>
                </b-tab>
            </b-tabs>
        </div>
    </Layout>
</template>
<script>
import Layout from "../../../layouts/main.vue"
import EmployeeAttendes from './EmplyeesAttendes.vue'
import employeeCalender from "./employeeCalender.vue";
export default {
    components: {
    Layout,
    EmployeeAttendes,
    employeeCalender
  },
  data() {
    return{
        activate_calendar_attendance: {}, 
    }
  },
  methods: {
    refreshHrEmp() {
      this.activate_hr_employees.get(1);
      this.activate_hr_employees.getHrDepatments();
      this.activate_hr_employees.getJobTitles();
      this.activate_hr_employees.getAccounts();
      this.activate_hr_employees.getCashAccounts();
    },
  },
}
</script>
